
function name2Type (name) {
  var type = {
    tSina : 1,
    qzone : 2,
    tQQ:2,
    renren:3,
    weixin : 12
  }
  return type[name]
}
export function addBind (name, success) {
  let callbackName = 'toLoginCallback'
  let type = name2Type(name)
  document.domain = 'ximalaya.com'
  window[callbackName] = function (data) {
    success(data)
    window[callbackName] = null
  }
  window.open(`/passport/auth/${type}/authorize?customerFunction=${callbackName}`, '', 'height=560, width=760, left=400')
}


// WEBPACK FOOTER //
// ./src/third-part.js